import { render, staticRenderFns } from "./add-prescription-popup.vue?vue&type=template&id=49bda3b1&scoped=true"
import script from "./add-prescription-popup.vue?vue&type=script&lang=js"
export * from "./add-prescription-popup.vue?vue&type=script&lang=js"
import style0 from "./add-prescription-popup.vue?vue&type=style&index=0&id=49bda3b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bda3b1",
  null
  
)

export default component.exports